<script>
	export let height = '100%';
</script>

<svg
	data-svg-carbon-icon="AirportLocation32"
	xmlns="http://www.w3.org/2000/svg"
	{height}
	fill="currentColor"
	viewBox="0 0 32 32"
	><path
		d="M30 15h-6.07A8.0076 8.0076 0 0 0 17 8.0693V2h-2v6.0693A8.0076 8.0076 0 0 0 8.07 15H2v2h6.07A8.0076 8.0076 0 0 0 15 23.9307V30h2v-6.0693A8.0076 8.0076 0 0 0 23.9305 17H30Zm-14 7a6 6 0 1 1 6-6 6.0066 6.0066 0 0 1-6 6Z"
	/></svg
>
